import { createEntityAdapter } from "@reduxjs/toolkit";
import { DevelopmentArea } from "./dataTypes";

export const developmentAreaAdapter = createEntityAdapter<DevelopmentArea>({});
